import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Alert, Button, Container, Modal, Table } from '@itds/elements/index.js';

import H1 from '@brokerage/components/H1';

import EditDrawer from './Edit';

import { Api } from '@brokerage/utils/Api';

const List = () => {
  const [admins, setAdmins] = useState([]);
  const [admin, setAdmin] = useState(null);
  const [modal, setModal] = useState(false);
  const [success_message, setSuccessMessage] = useState();
  const [error_message, setErrorMessage] = useState();

  useEffect(() => {
    loadAdmins();
  }, []);

  const loadAdmins = () => {
    Api.loadAdmins().then(response => {
      setAdmins(response.data);
    });
  };

  const handleSave = () => {
    setAdmin(null);
    loadAdmins();
  };

  const handleDelete = (admin, e) => {
    e.stopPropagation();
    setModal('delete');
    setAdmin(admin);
  };

  const confirmDelete = () => {
    window.scrollTo(0, 0);

    Api.deleteAdmin(admin.id)
      .then(() => {
        setModal(null);
        setAdmin(null);
        loadAdmins();
        setSuccessMessage('Admin deleted');
        setTimeout(() => {
          setSuccessMessage(null);
        }, 2000);
      })
      .catch(() => {
        setModal(null);
        setAdmin(null);
        setErrorMessage('Unable to delete the Admin at this time');
        setTimeout(() => {
          setErrorMessage(null);
        }, 2000);
      });
  };

  return (
    <Container>
      <EditDrawer
        admin={admin}
        onClose={setAdmin.bind(null, null)}
        onSave={handleSave}
        show={!modal && !!admin}
      />

      {error_message ? <Alert type='error'>{error_message}</Alert> : null}
      {success_message ? <Alert type='success'>{success_message}</Alert> : null}

      <div style={{ display: 'flex', alignItems: 'center' }}>
        <H1>Admins</H1>

        <Button
          onClick={setAdmin.bind(null, { name: '', email: '', password: '' })}
          style={{ marginLeft: 'auto', marginBottom: 30 }}
        >
          Add Admin
        </Button>
      </div>

      <Table
        columns={[
          {
            id: 'name',
            label: 'name'
          },
          {
            id: 'email',
            label: 'email'
          },
          {
            id: 'is_locked',
            label: '',
            render: row => {
              return row.is_locked ? <i className='mdi mdi-lock' style={{ fontSize: 20 }} /> : null;
            }
          },
          {
            id: 'actions',
            render: admin => {
              return (
                <Button
                  color='RED'
                  inline={true}
                  onClick={handleDelete.bind(null, admin)}
                  small={true}
                >
                  Delete
                </Button>
              );
            },
            styles: { textAlign: 'right' }
          }
        ]}
        data={admins}
        onRowClick={setAdmin}
      />

      {modal === 'delete' ? (
        <Modal
          buttons={[
            {
              color: 'RED',
              children: 'Confirm Delete',
              onClick: confirmDelete,
              style: { marginLeft: 'auto' }
            }
          ]}
          contained={true}
          onClose={() => {
            setModal(null);
          }}
          title={`Delete "${admin.name}"`}
        >
          <div style={{ padding: 40, fontSize: 16, textAlign: 'center', lineHeight: '1.5em' }}>
            Are you sure you want to delete "{admin.name}"?
          </div>
        </Modal>
      ) : null}
    </Container>
  );
};

List.propTypes = {
  setErrorMessage: PropTypes.func,
  setSuccessMessage: PropTypes.func
};

export default List;
